import { Action, configureStore, Reducer, ReducersMapObject, ThunkAction } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { composerDraftsSlice } from '@/features/MessageComposer';
// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { authReducer } from '@/entities/Auth';
// eslint-disable-next-line dmtrs-fsd-path-checker/layer-imports
import { profileReducer } from '@/entities/Profile';
import { rtkApi, $api } from '@/shared/api';
import { StateSchema, ThunkExtraArg } from '../../types/store';
import { createReducerManager } from './reducerManager';

export function createReduxStore(initialState?: StateSchema) {
  const rootReducers: ReducersMapObject<StateSchema> = {
    auth: authReducer,
    composerDrafts: composerDraftsSlice.reducer,
    profile: profileReducer,
    [rtkApi.reducerPath]: rtkApi.reducer,
  };

  const reducerManager = createReducerManager(rootReducers);

  const extraArg: ThunkExtraArg = {
    api: $api,
  };

  const store = configureStore({
    reducer: reducerManager.reduce as Reducer<StateSchema>,
    preloadedState: initialState,
    // devTools: __IS_DEV__,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: {
          extraArgument: extraArg,
        },
      }).concat(rtkApi.middleware),
  });

  // Включает события возврата фокуса и восстановления сети. Сами по себе они ничего
  // не меняют: запрос обновится только там, где refetchOnFocus задан явно.
  setupListeners(store.dispatch);

  // @ts-ignore
  store.reducerManager = reducerManager;

  return store;
}

export type AppStore = ReturnType<typeof createReduxStore>;
export type AppState = ReturnType<AppStore['getState']>;
export type AppDispatch = ReturnType<typeof createReduxStore>['dispatch'];
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, AppState, unknown, Action>;
